export const RMA_INTAKE_CHANNEL_KEY = 'intakeChannel';
export const RMA_TASK_ID = 'rma-receiving';
